// extracted by mini-css-extract-plugin
export default {"addFormContainer":"AddNewForm_addFormContainer__QO+td","topItems":"AddNewForm_topItems__ZKyzi","formBuilderContainer":"AddNewForm_formBuilderContainer__uke0e"};